<app-nav [titulo]="'Modificar inquilino ' + getTenantName(tenant)" descripcion="Aquí podrá ver todos los detalles del inquilino seleccionado y modificarlos.">
    <div class="edit-tenant basic-avm-editor">
        <form class="edit-tenant-form" [formGroup]="tenantFG">
            <mat-horizontal-stepper class="form-stepper" [linear]="!tenant" #stepper>
                <mat-step [completed]="isGeneralSectionValid()">
                    <div class="form-step">
                        <ng-template matStepLabel>Información general</ng-template>
                        <h3 class="form-step-title">
                            Información general
                        </h3>
                        <span class="form-step-description">
                            Para comenzar complete la información del inquilino.
                        </span>
                        <mat-radio-group class="form-radio-line" formControlName="tipoPersona" color="primary">
                            <span class="radio-line-label">
                                Tipo de persona
                            </span>
                            <div class="radios">
                                <mat-radio-button value="FISICA">Persona física</mat-radio-button>
                                <mat-radio-button value="JURIDICA">Persona jurídica</mat-radio-button>
                            </div>
                        </mat-radio-group>
                        <app-physical-person-form [formGroup]="physicalPersonFG" [personType]="personType">
                            <mat-form-field class="garantor-form-field email-form-field" appearance="outline">
                                <mat-label>E-Mail</mat-label>
                                <input matInput [formControl]="tenantFG.controls.email">
                                <mat-error *ngIf="tenantFG.controls.email.hasError('required')">
                                    Por favor ingrese el email
                                </mat-error>
                                <mat-error *ngIf="tenantFG.controls.email.hasError('email')">
                                    Por favor ingrese un email válido
                                </mat-error>
                                <mat-hint>
                                    Este email será utilizado para notificaciones
                                </mat-hint>
                            </mat-form-field>
                        </app-physical-person-form>
                        <app-legal-person-form [formGroup]="legalPersonFG" [personType]="personType">
                            <mat-form-field class="garantor-form-field email-form-field" appearance="outline">
                                <mat-label>E-Mail</mat-label>
                                <input matInput [formControl]="tenantFG.controls.email">
                                <mat-error *ngIf="tenantFG.controls.email.hasError('required')">
                                    Por favor ingrese el email
                                </mat-error>
                                <mat-error *ngIf="tenantFG.controls.email.hasError('email')">
                                    Por favor ingrese un email válido
                                </mat-error>
                                <mat-hint>
                                    Este email será utilizado para notificaciones
                                </mat-hint>
                            </mat-form-field>
                        </app-legal-person-form>
                        <div class="form-step-buttons">
                            <button mat-raised-button color="primary" class="garantor-button" (click)="isGeneralSectionValid() && stepper.next()">Siguiente</button>
                            <button mat-raised-button color="accent" type="button" class="garantor-button" (click)="createTenant()" *ngIf="tenant">Guardar y salir</button>
                        </div>
                    </div>
                </mat-step>
                <mat-step [completed]="isRepresentativeSectionValid()">
                    <div class="form-step">
                        <ng-template matStepLabel>Representante</ng-template>
                        <h3 class="form-step-title">
                            Representante
                        </h3>
                        <span class="form-step-description">
                            Complete los datos del representante (si corresponde).
                        </span>
                        <app-representative-form [formGroup]="representativeFG" [personType]="personType"></app-representative-form>
                        <div class="form-step-buttons">
                            <button mat-button color="primary" type="button" class="garantor-button" matStepperPrevious>Atras</button>
                            <button mat-raised-button color="primary" class="garantor-button" (click)="isRepresentativeSectionValid() && stepper.next()">Siguiente</button>
                            <button mat-raised-button color="accent" type="button" class="garantor-button" (click)="createTenant()" *ngIf="tenant">Guardar y salir</button>
                        </div>
                    </div>
                </mat-step>
                <mat-step [completed]="isAddressSectionValid()" *ngIf="personType === 'JURIDICA'">
                    <div class="form-step">
                        <ng-template matStepLabel>Dirección</ng-template>
                        <h3 class="form-step-title">
                            Dirección
                        </h3>
                        <span class="form-step-description">
                            Complete los datos de la dirección del inquilino.
                        </span>
                        <app-address-form [formGroup]="addressFG"></app-address-form>
                        <div class="form-step-buttons">
                            <button mat-button color="primary" type="button" class="garantor-button" matStepperPrevious>Atras</button>
                            <button mat-raised-button color="primary" class="garantor-button" (click)="isAddressSectionValid() && stepper.next()">Siguiente</button>
                            <button mat-raised-button color="accent" type="button" class="garantor-button" (click)="createTenant()" *ngIf="tenant">Guardar y salir</button>
                        </div>
                    </div>
                </mat-step>
                <mat-step>
                    <div class="form-step details-form-step">
                        <ng-template matStepLabel>Resumen</ng-template>
                        <h3 class="form-step-title">
                            Resumen
                        </h3>
                        <span class="form-step-description">
                            Por favor verifique los datos del nuevo inquilino y presione confirmar.
                        </span>
                        <div class="tenant-details-content-container">
                            <app-tenant-details-content [tenant]="getResultingTenant()"></app-tenant-details-content>
                        </div>
                        <div class="form-step-buttons">
                            <button mat-button color="primary" type="button" class="garantor-button" matStepperPrevious>Atras</button>
                            <button mat-raised-button color="accent" type="button" class="garantor-button" (click)="createTenant()">Confirmar</button>
                        </div>
                    </div>
                </mat-step>
            </mat-horizontal-stepper>
        </form>
    </div>
</app-nav>
